import { BannerFormProvider } from "../../contexts/BannerFormContext";
import { CreateBannerContent } from "./CreateBannerContent";

type PropTypes = {
  onBack: () => void;
};
export const CreateBanner = ({ onBack }: PropTypes) => {
  return (
    <BannerFormProvider>
      <CreateBannerContent onBack={onBack} />
    </BannerFormProvider>
  );
};
